<template>
    <div
        class="header_card"
        :class="{
            fixed_style: isFixed,
        }"
    >
        <div class="base_div header_card_content">
            <img src="../../../assets/logo1.svg" />
            <div class="header_button_card">
                <div
                    class="header_button_item"
                    v-for="(item, index) in buttons"
                    :key="index"
                    :class="{
                        header_button_select: key === item.key,
                    }"
                    @click="go(item.to)"
                >
                    {{ item.name }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HeaderCard',
    data () {
        return {
            buttons: [{
                name: '联系智煜',
                to: '/contact',
                key: 'Contact'
            }, {
                name: '产品与服务',
                to: '/product',
                key: 'Product'
            }, {
                name: '关于智煜',
                to: '/about',
                key: 'About'
            }, {
                name: '首页',
                to: '/',
                key: 'Home'
            }]
        }
    },
    computed: {
        isFixed () {
            return ['Home', 'About', 'Product', 'Contact'].indexOf(this.key) > -1
        },
        key () {
            console.log(this.$route.name)
            return this.$route.name
        }
    },
    methods: {
        go (url) {
            this.$router.push(url)
        }
    }
}
</script>
<style >
.header_card {
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 9999;
}
.header_card_content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
}
.header_card_content img {
    width: 179px;
    height: auto;
}
.header_button_card {
    font-size: 20px;
    font-weight: 500;
}
.header_button_card .header_button_item {
    float: right;
    margin-left: 40px;
    color: #10a4b0;
    cursor: pointer;
}
.header_button_select {
    color: #706bb0 !important;
}
.fixed_style {
    position: fixed;
    top: 0;
    width: 100vw;
    min-width: 1300px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Header/HeaderCard.vue